export default __webpack_public_path__ + "static/media/onedrive-long.efc96d28.svg";